import {createTheme} from "@mui/material/styles";
import {nlNL} from '@mui/x-date-pickers/locales'
import Loader from "@memaro/components/Loader.tsx";

export const defaultThemeOptions: Parameters<typeof createTheme>[0] = {
    components: {
        MuiIcon: {
            defaultProps: {
                color: "primary"
            }
        },
        MuiButton: {
            defaultProps: {
                loadingIndicator: <Loader size={20}/>,
            },
        },
        MuiCssBaseline: {
            styleOverrides: {
                p: {
                    fontSize: '1rem',
                    lineHeight: 1.6,
                    marginTop: 0,
                    marginBottom: '1rem',
                }
            }
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    background: "transparent"
                },
                head: {
                    fontWeight: 'bold',
                    fontSize: '0.875rem'
                },
                footer: {
                    fontWeight: 'bold',
                    fontSize: '0.875rem'
                }
            }
        },
        MuiDialog: {
            styleOverrides: {
                root: {
                    '.MuiDialogActions-root button': {
                        minWidth: 100,
                    }
                },
            }
        },
        MuiMobileStepper: {
            styleOverrides: {
                root: {
                    background: 'transparent'
                }
            }
        }
    },
    palette: {
        background: {
            default: "#bab29e",
            paper: "#e9e8e6"
        },
        primary: {
            main: "#2c3e50"
        },
        secondary: {
            main: "#D9D7D4"
        },
        error: {
            main: "#B15E6C"
        },
        info: {
            main: "#415B76"
        },
        text: {
            primary: '#2c3e50',
            secondary: '#2c3e50',
            disabled: '#2c3e50'
        }
    },
    typography: {
        fontFamily: "Playfair Display, serif",
        h1: {
            fontSize: '3rem',
            fontWeight: 700,
            marginTop: '1rem',
            marginBottom: '2.5rem',
        },
        h2: {
            fontSize: '1.5rem',
            fontWeight: 800,
        },
    }
}

export default createTheme(defaultThemeOptions, nlNL);
